import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    amount: 'Amount',
    amountAboveThreshold:
      'Transfers of {0} or more cannot be scheduled over multiple deadlines. Please change the parameters or the amount of your transfer.',
    continue: 'Continue',
    insufficientAmount: 'This amount is too low',
    insufficientFunds: 'Balance too low to make this transfer',
    label: 'Description (optional)',
    labelError: 'Please remove special characters',
    labelMaxLength: 'The description cannot exceed {0} characters',
    labelPlaceholder: 'Supplier payment',
    sendMoney: 'Make a transfer',
  },
  fr: {
    amount: 'Montant',
    amountAboveThreshold:
      'Les virements à partir de {0} ne sont pas programmables sur plusieurs échéances. Veuillez modifier les paramètres de programmation ou le montant de votre virement.',
    continue: 'Continuer',
    insufficientAmount: 'Ce montant est insuffisant',
    insufficientFunds: 'Solde insuffisant pour effectuer ce virement',
    label: 'Libellé (facultatif)',
    labelError: 'Veuillez retirer les caractères spéciaux',
    labelMaxLength: 'Le libellé ne peut pas dépasser {0} caractères',
    labelPlaceholder: 'Paiement fournisseur',
    sendMoney: 'Effectuer un virement',
  },
} as const);
